import { useState } from "react"
import { Link } from "react-router-dom"
import { requestPasswordReset } from "~/api/auth"
import { PageShell } from "~/components/PageShell"

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    if (!email.trim()) return
    setSubmitting(true)
    try {
      await requestPasswordReset(email.trim())
      setSubmitted(true)
    } catch (err) {
      setError(err instanceof Error ? err.message : "Request failed")
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <PageShell innerClassName="max-w-lg w-full">
      <section className="w-full rounded-lg bg-[var(--color-surface-card)] p-6 shadow-sm">
        <h1 className="text-2xl font-semibold text-[var(--color-text-primary)]">
          Forgot password
        </h1>
        {submitted ? (
          <p className="mt-4 text-sm text-[var(--color-text-secondary)]" role="status">
            If an account exists for that email, we sent reset instructions. Check your inbox.
          </p>
        ) : (
          <>
            <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
              Enter your email and we&apos;ll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit} className="mt-6 flex flex-col gap-4">
              <label className="block text-sm font-medium text-[var(--color-text-primary)]">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="rounded-lg border border-[var(--color-divider)] bg-[var(--color-bg-primary)] px-4 py-3 text-[var(--color-text-primary)] focus:border-[var(--color-divider)] focus:outline-none focus:ring-1 focus:ring-[var(--color-divider)]"
              />
              {error && (
                <p className="text-sm text-red-600" role="alert">
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={submitting}
                className="rounded-lg bg-[var(--color-text-primary)] px-6 py-3 font-medium text-[var(--color-surface-card)] transition hover:opacity-90 disabled:opacity-50"
              >
                {submitting ? "Sending…" : "Send reset link"}
              </button>
            </form>
          </>
        )}
      </section>
      <p className="text-center text-sm text-[var(--color-text-secondary)]">
        <Link to="/login" className="text-[var(--color-text-primary)] underline">
          Back to log in
        </Link>
      </p>
    </PageShell>
  )
}
